module.exports = __webpack_public_path__ + "static/media/galerija_2013 (30).4c35a299.jpg";